import { usePersistedDateRange } from "@/hooks/userSettings/usePersistedDateRange";

/**
 * The H2 monitor's date range, remembered for the signed-in user.
 *
 * Previously kept in this browser's storage, which meant the range was lost on another device
 * and shared between two Geotab users of the same browser profile.
 */
export function useFuelCellFromToDate() {
  return usePersistedDateRange({ scope: "fuelCell.dateRange", defaultLookbackDays: 7 });
}
